var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 14,
    viewBox: "0 0 90 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.63.645 1.782 3.612 3.986.579-2.884 2.811.681 3.97-3.565-1.874-3.565 1.874.68-3.97-2.883-2.811 3.986-.58L82.63.646zM63.63.645l1.782 3.612 3.986.579-2.884 2.811.681 3.97-3.565-1.874-3.565 1.874.68-3.97-2.883-2.811 3.986-.58L63.63.646z",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.47 10.025-3.897 2.049.744-4.34-3.153-3.073 4.357-.633L7.47.08l1.949 3.948 4.357.633-3.153 3.073.744 4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.63.645 1.782 3.612 3.986.579-2.884 2.811.681 3.97-3.565-1.874-3.565 1.874.68-3.97-2.883-2.811 3.986-.58L26.63.646zM45.63.645l1.782 3.612 3.986.579-2.884 2.811.681 3.97-3.565-1.874-3.565 1.874.68-3.97-2.883-2.811 3.986-.58L45.63.646z",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars1);
export default __webpack_public_path__ + "static/media/stars1.55098b6a.svg";
export { ForwardRef as ReactComponent };